module.exports = __webpack_public_path__ + "img/Photo_1__Construction_986_82_244.55e7f9b9.jpg";